import { get, put } from './http'
import { CONVERSIONS, APPROVE_CONVERSION } from '../utils/routes'

export const getAllConversions = (query) => get(`${CONVERSIONS}?${query}`)

export const approveConversion = (payload, id) => put(`${APPROVE_CONVERSION}/${id}`, payload)
